/**
 * Frontend Release History (External user)
 *
 * This file tracks all external user frontend releases with their versions,
 * builds, and deployment information.
 */

const RELEASES = [
  {
    id: 'ext-v4.3.0+01',
    version: 'ext-v4.3.0',
    title: 'Add post-exam application support',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-12-11',
      date: '2025-12-11',
      issues: [90, 99],
      commit: {
        message: 'Add post-exam application support',
        date: '2025-12-11',
        sha: '4ec401983fd9d278d7d43e40aa1821119ebf7ea2',
      },
    },
  },
  {
    id: 'ext-v4.3.0-rc.1+03',
    version: 'ext-v4.3.0-rc.1',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '03',
      author: 'symeon',
      startDate: '2025-12-10',
      date: '2025-12-10',
      issues: [90, 99],
      commit: {
        message: 'Add build metadata to releases and display in footer tooltips',
        date: '2025-12-10',
        sha: 'b2f67e93c61e0e21408c9a3e2294b876b0aeb7c3',
      },
    },
  },
  {
    id: 'ext-v4.3.0-rc.1+02',
    version: 'ext-v4.3.0-rc.1',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2025-12-01',
      date: '2025-12-10',
      issues: [90, 99],
      commit: {
        message: 'Update UI texts for post-exam applications',
        date: '2025-12-10',
        sha: 'a329590930f2096d390cf61d07953d7a58761d6f',
      },
    },
  },
  {
    id: 'ext-v4.3.0-rc.1+01',
    version: 'ext-v4.3.0-rc.1',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-27',
      date: '2025-12-10',
      issues: [90, 99],
      commit: {
        message: 'Add post-exam application support (RC 1)',
        date: '2025-11-28',
        sha: '03d728e4b825ea1ccc9a54821646a6795b63b144',
      },
    },
  },
  {
    id: 'ext-v4.2.6+01',
    version: 'ext-v4.2.6',
    title: 'Add accessibility widget',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-16',
      date: '2025-10-16',
      issues: [26],
      commit: {
        message: 'Add accessibility widget',
        date: '2025-10-16',
        sha: 'd04e6a2cf07cbc63a4424fb4d139e5c7a4d0f16a',
      },
    },
  },
  {
    id: 'ext-v4.2.5+01',
    version: 'ext-v4.2.5',
    title: 'Production release v4.2.5',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-07',
      date: '2025-10-07',
      issues: [],
      commit: {
        message: 'Production release v4.2.5',
        date: '2025-10-07',
        sha: '51651cd223fae89ccc1c899a97f4520fe44f4326',
      },
    },
  },
  {
    id: 'ext-v4.2.5-dev.1+01',
    version: 'ext-v4.2.5-dev.1',
    title: 'Change date format and update download date (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-02',
      date: '',
      issues: [60, 45],
      commit: {
        message: 'Change date format (Issue #60) and update download date (Issue #45)',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.4+01',
    version: 'ext-v4.2.4',
    title: 'Fix submit choice text',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-08',
      date: '',
      issues: [],
      commit: {
        message: 'Fix submit choice text',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.3+01',
    version: 'ext-v4.2.3',
    title: 'Translate form validation messages',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-30',
      date: '',
      issues: [],
      commit: {
        message: 'Translate form validation messages',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.2+01',
    version: 'ext-v4.2.2',
    title: 'Update translations of "Application reappraisal" as "Reevaluation of decision"',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-23',
      date: '',
      issues: [],
      commit: {
        message: 'Update translations of "Application reappraisal" as "Reevaluation of decision"',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.1+01',
    version: 'ext-v4.2.1',
    title: 'Update text of Application Status field value',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-22',
      date: '',
      issues: [],
      commit: {
        message: 'Update text of Application Status field value',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.0+01',
    version: 'ext-v4.2.0',
    title: 'Add reappraisal applications support',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-04',
      date: '',
      issues: [],
      commit: {
        message: 'Add reappraisal applications support',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.0-rc.3+01',
    version: 'ext-v4.2.0-rc.3',
    title: 'Second test changes (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-03',
      date: '',
      issues: [],
      commit: {
        message: 'Second test changes',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.0-rc.2+01',
    version: 'ext-v4.2.0-rc.2',
    title: 'First test changes (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-01',
      date: '',
      issues: [],
      commit: {
        message: 'First test changes',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.0-rc.1+01',
    version: 'ext-v4.2.0-rc.1',
    title: 'Add reappraisal entries in history chart (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-06-09',
      date: '',
      issues: [],
      commit: {
        message: 'Add reappraisal entries in history chart. Minor fixes.',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.0-dev.3+01',
    version: 'ext-v4.2.0-dev.3',
    title: 'Add reappraisal entries in history chart (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-05-13',
      date: '',
      issues: [],
      commit: {
        message: 'Add reappraisal entries in history chart. Minor fixes.',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.0-dev.2+01',
    version: 'ext-v4.2.0-dev.2',
    title: 'Split frontend and backend versions for debugging (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-04-11',
      date: '',
      issues: [],
      commit: {
        message: 'Split frontend and backend versions for debugging. Minor fixes.',
        date: '',
        sha: '',
      },
    },
  },
  {
    id: 'ext-v4.2.0-dev.1+01',
    version: 'ext-v4.2.0-dev.1',
    title: 'Reappraisals 2024 (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2024',
      date: '',
      issues: [],
      commit: {
        message: 'Reappraisals 2024',
        date: '',
        sha: '',
      },
    },
  },
]

// Active release = first element
export const FRONTEND_RELEASE = `${RELEASES[0].version} (build ${RELEASES[0].build.number})`

// Export RELEASES array for use in config
export { RELEASES }
